import "./TruckBooking.module.css";
import Header from "@/reusable_sections/Header";
import BringTheHeatToYourEvent from "./sections/BringTheHeatToYourEvent";
import CateringInquiry from "./sections/CateringInquiry";
import CateringFaq from "./sections/CateringFaq";
import Footer from "@/reusable_sections/Footer";
export default function TruckBookingPage() {
  return <div>
      <Header />
      <BringTheHeatToYourEvent />
      <CateringInquiry />
      <CateringFaq />
      <Footer />
    </div>;
}